<template>
  <div>
    <el-input-number
      v-bind="$attrs"
      v-on="$listeners"
      :controls-position="$attrs.controlsPosition || $attrs['controls-position'] || 'right'"
      :controls="controls"
      ref="inputNumber"
    >
    </el-input-number>
  </div>
</template>

<script>
export default {
  name: 'ShInputNumber',
  props: {
    controls: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: 'right'
    }
  },
  mounted() {
    this.setTextAlign()
  },
  // watch: {
  //   textAlign(newVal) {
  //     if (newVal !== '') {
  //       this.setTextAlign()
  //     }
  //   }
  // },
  methods: {
    setTextAlign() {
      const inputDom = this.$refs.inputNumber.$el.querySelector('.el-input__inner')
      if (inputDom && this.textAlign) {
        inputDom.style.textAlign = this.textAlign
      }
    }
  }
}
</script>
